const isSSL = (location.hostname == 'localhost')? 'http': 'https';
const connection = { 'on': function() {}, 'emit': function() {} };

module.exports = {
	connection
}
